// extracted by mini-css-extract-plugin
module.exports = {"container":"error-not-found_container__13W3c","title":"error-not-found_title__lDfOH","desc":"error-not-found_desc__2rW1Z"};